import React from "react";
import { useTranslation } from "../i18n/TranslationProvider";

import { useHistory } from "react-router-dom";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import theme from "../index.scss";
import Sallie from "../images/Sallie-Oops.png";
import SubmitButton from "./StyledComponents/SubmitButton";

const Oops = () => {
  const history = useHistory();
  const { t } = useTranslation();
  return (
    <Row
      style={{ color: theme.teal }}
      className="d-flex justify-content-center text-center"
    >
      <Col>
        <Row>
          <Col>
            <h2>{t("helpPage.oops.header")}</h2>
          </Col>
        </Row>
        <Row className="d-flex justify-content-center">
          <Col xs={8} md={4}>
            <img
              style={{ objectFit: "cover", maxWidth: "100%" }}
              alt="Apologetic Dog"
              src={Sallie}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <h4>{t("helpPage.oops.subheading")}</h4>
          </Col>
        </Row>
        <Row className="d-flex justify-content-center">
          <Col md={6}>
            <p style={{ color: "initial" }}>
              {t("helpPage.oops.body")}
            </p>
          </Col>
        </Row>
        <Row className="d-flex flex-column align-items-center">
          <SubmitButton onClick={history.goBack}>{t("helpPage.helpPage.goBack")}</SubmitButton>
          <SubmitButton onClick={() => history.push("/help")}>
            {t("helpPage.oops.requestHelp")}
          </SubmitButton>
        </Row>
      </Col>
    </Row>
  );
};

export default Oops;